import * as React from 'react';
import * as Classes from '../common/classes';
import { MouseEventHandler, ReactNode } from 'react';
import classNames from 'classnames';

type WizardStepsProps = {
  children?: ReactNode | undefined;
};

export const WizardSteps: React.FC<WizardStepsProps> = ({ children }) => {
  return <div className={Classes.WIZARD_STEPS}>{children}</div>;
};

type WizardStepProps = {
  active?: boolean;
  visited?: boolean;
  disabled?: boolean;
  error?: boolean | string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  children?: ReactNode | undefined;
  last?: boolean;
};

export const WizardStep: React.FC<WizardStepProps> = ({
  children,
  active,
  visited,
  disabled,
  onClick,
  error,
  last,
}) => {
  let content = (
    <>
      <div
        onClick={!active && !disabled ? onClick : undefined}
        className={classNames(Classes.WIZARD_STEP, {
          [Classes.WIZARD_STEP_VISITED]: visited && !active,
          [Classes.WIZARD_STEP_ACTIVE]: active,
          [Classes.WIZARD_STEP_DISABLED]: disabled,
          [Classes.WIZARD_STEP_WAIT]: !onClick,
          [Classes.WIZARD_STEP_ERROR]: !!error,
        })}
        title={typeof error === 'string' ? error : undefined}
      >
        {children}
      </div>
    </>
  );
  if (!last) {
    return (
      <>
        {content}
        <div className={Classes.WIZARD_STEP_DIVIDER} />
      </>
    );
  } else {
    return content;
  }
};
